<template>
    <div class="action-bar" v-if="actions.length || actionsMore.length">
        <template v-for="(action, index) in actions">
            <btn class="action-item"
                 :key="index"
                 v-bind="mergeActionDefaults(action)"
                 @close="closeHandler(action)"/>
        </template>

        <template v-if="actionsMore.length">
            <btn class="action-item" theme="link" size="sm" icon="dots-horizontal" label="Weiteres"/>
            <popover auto-bind align-left>
                <navigation>
                    <nav-item v-for="(action, index) of actionsMore"
                              :key="index"
                              v-bind="mergeActionDefaults(action)"
                              @close="closeHandler(action)"
                    />
                </navigation>
            </popover>
        </template>
    </div>
</template>

<style lang="scss">
    .action-bar {
        padding: 0 calc(#{$spacer-3} - #{$spacer-2});

        .action-item {
            color: $dark-70;
            padding: $spacer-2;
            border: none;

            &.active {
                color: $red;
                font-weight: bold;
                box-shadow: inset 0 -4px 0 $red;
            }
        }

        @include media-breakpoint-down("sm") {
            padding: $spacer-2 0;

            .popover {
                right: $spacer-2;
                max-width: 700px;

                .nav-link {
                    justify-content: center;
                }
            }
            .action-item {
                display: block;
                padding: $spacer-1;

                &.active {
                    box-shadow: none;
                }
            }
        }

        @include media-breakpoint-down("xs") {
            right: $spacer-1;
        }
    }
</style>

<script>
    export default {
        props: {
            actions: {type: Array, default: () => []},
            actionsMore: {type: Array, default: () => []},
        },

        methods: {
            mergeActionDefaults(action) {
                return {
                    theme: 'link',
                    size: 'sm',
                    ...action,
                };
            },

            closeHandler(action) {
                if (action.hasOwnProperty("closed") && action.closed instanceof Function) {
                    action.closed();
                }
            },
        },
    };
</script>